<template>
    <div class="cz2__steps-options__actions--share cz2__steps-options__actions--sb-share">
        <sb-button
            @click="sharePop"
            variant="tertiary"
            heightVariant="medium"
            width="auto"
        >
            <span>
                {{$t('ACTION_SHARE')}}
            </span>
        </sb-button>

        <sb-button
            @click="downloadPopImage"
            variant="primary"
            heightVariant="medium"
            width="auto"
        >
            <span>
                {{$t('ACTION_DOWNLOAD')}}
            </span>
        </sb-button>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps-options__actions--sb-share {
            display: flex;

            width: 100% !important;
            max-width: 450px !important;

            button {
                flex: 1 1 0 !important;
            }
        }
    }
</style>

<script>
    import axios from 'axios';
    import FileSaver from 'file-saver';

    import share from '../assets/icons/share-icons/share.svg';
    import download from '../assets/icons/share-icons/download.svg';

    import SbButton from './SbButton.vue';

    export default {
        components: {
            SbButton,
        },

        data() {
            return {
                shareIcon: share,
                downloadIcon: download,
                fbScriptSrc: 'https://connect.facebook.net/en_US/sdk.js',
            };
        },

        computed: {
            boxName() {
                return this.$store.state.customizer.boxName;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            boxNames() {
                return Object.values(this.$store.state.customizer.boxNamesByController).join('_');
            },

            fileName() {
                const boxName = this.isTwoPack ? this.boxNames : this.boxName;

                return boxName && boxName.length > 0 ? boxName : this.$t('NO_NAME');
            },
        },

        mounted() {
            this.checkForFbScript();
        },

        methods: {
            sharePop() {
                let popImageUrl = null;

                this.$store.dispatch('customizerDone', { saveOnly: true })
                    .then((recipeData) => {
                        const preview = recipeData.recipe.views.find((view) => view.code === 'Preview');

                        if (window.navigator.share) {
                            fetch(preview.previewPng).then((response) => response.blob()).then((image) => {
                                const fileName = `${this.boxName}.png`;

                                const data = {
                                    files: [
                                        new File([image], fileName, {
                                            type: image.type,
                                        }),
                                    ],
                                    title: this.boxName,
                                };

                                window.navigator.share(data);
                            });
                        } else {
                            popImageUrl = `https:${preview.previewPng}`;

                            // eslint-disable-next-line no-undef
                            FB.ui({
                                method: 'share',
                                href: popImageUrl,
                            }, () => {});
                        }
                    });
            },

            downloadPopImage() {
                let popImageUrl = null;

                this.$store.dispatch('customizerDone', { saveOnly: true })
                    .then((recipeData) => {
                        const preview = recipeData.recipe.views.find((view) => view.code === 'Preview');

                        popImageUrl = preview.previewPng;

                        axios.get(popImageUrl, { responseType: 'blob' }).then((response) => {
                            const fileName = `${this.fileName}.png`;

                            FileSaver.saveAs(response.data, fileName);
                        });
                    });
            },

            checkForFbScript() {
                if (window.FB == null) {
                    this.addFacebookScript();
                }
            },

            addFacebookScript() {
                const facebookScript = document.createElement('script');

                facebookScript.setAttribute('src', this.fbScriptSrc);

                // FB won't load with these from the "real" test page on CDN...
                // facebookScript.setAttribute('crossorigin', 'anonymous');
                // facebookScript.setAttribute('async', true);
                // facebookScript.setAttribute('defer', true);

                document.body.appendChild(facebookScript);

                window.fbAsyncInit = () => {
                    // eslint-disable-next-line no-undef
                    FB.init({
                        appId: '2802097273142792',
                        autoLogAppEvents: true,
                        xfbml: true,
                        version: 'v14.0',
                    });
                };
            },
        },
    };
</script>
